module.exports = __webpack_public_path__ + "static/media/ai_flow.d3e3a4f3.png";